import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../node_modules/prop-types/index.js';
import React, { useMemo, useCallback } from 'react';
import classnames from '../../node_modules/classnames/index.js';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { styled, useThemeProps, Snackbar, Stack } from '@mui/material';
import NotificationStackItem from './NotificationStackItem.js';
import NotificationEventLifecycle from './NotificationEventLifecycle.js';
import { getNotificationState } from '../../cinnamon-core/es/modules/notifications/selectors.js';
import { NotificationHandlerType } from '../../cinnamon-core/es/modules/notifications/constants.js';
import { WebNotificationHandlerType } from '../../cinnamon-web/es/modules/notifications/constants.js';
import { removeNotification } from '../../cinnamon-core/es/modules/notifications/actions.js';
import { createComponentSlot } from '../../modules/styling/theme.js';

var _templateObject;

var _excluded = ["itemComponent", "itemProps", "maxMessageLength", "spacing", "width", "dismissOnNavigation", "className", "sx", "variant"];
var componentRoot = createComponentSlot({
  name: "CinNotificationStack",
  slot: "Root"
});

var NotificationStackBase = function NotificationStackBase(_ref) {
  var _ref$itemComponent = _ref.itemComponent,
      ItemComponent = _ref$itemComponent === void 0 ? NotificationStackItem : _ref$itemComponent,
      itemProps = _ref.itemProps,
      _ref$maxMessageLength = _ref.maxMessageLength,
      maxMessageLength = _ref$maxMessageLength === void 0 ? 200 : _ref$maxMessageLength,
      _ref$spacing = _ref.spacing,
      spacing = _ref$spacing === void 0 ? 1 : _ref$spacing,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 400 : _ref$width,
      _ref$dismissOnNavigat = _ref.dismissOnNavigation,
      dismissOnNavigation = _ref$dismissOnNavigat === void 0 ? true : _ref$dismissOnNavigat,
      className = _ref.className;
      _ref.sx;
      _ref.variant;
      var muiProps = _objectWithoutProperties(_ref, _excluded);

  var _useSelector = useSelector(function (state) {
    return getNotificationState(state);
  }),
      events = _useSelector.events;

  var dispatch = useDispatch();
  var location = useLocation();
  var dismissIds = useMemo(function () {
    return events.filter(function (e) {
      if (typeof dismissOnNavigation === "function") {
        return dismissOnNavigation(e);
      }

      return !!dismissOnNavigation;
    }).map(function (e) {
      return e.id;
    });
  }, [location]); // in future we could allow this to be overridden via a prop to allow custom action handling

  var getActionHandler = useCallback(function (action) {
    var handler = action ? typeof action === "string" ? {
      type: action
    } : action : undefined;

    switch (handler === null || handler === void 0 ? void 0 : handler.type) {
      case WebNotificationHandlerType.Reload:
        return function () {
          window.location.reload();
        };

      case WebNotificationHandlerType.Redirect:
        return function () {
          window.location.href = handler.url || window.location.href;
        };

      case NotificationHandlerType.None:
        return undefined;

      default:
        console.warn("Unsupported notification action type", action);
        return undefined;
    }
  }, []);
  return /*#__PURE__*/React.createElement(Snackbar, _extends({
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    }
  }, muiProps, {
    className: classnames(componentRoot.className, className),
    open: events.length > 0
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Stack, {
    spacing: spacing,
    sx: {
      width: width
    }
  }, events.map(function (e) {
    return /*#__PURE__*/React.createElement(NotificationEventLifecycle, {
      key: e.id,
      event: e,
      dismiss: dismissIds.includes(e.id),
      onDismiss: function onDismiss() {
        return dispatch(removeNotification(e.id));
      }
    }, /*#__PURE__*/React.createElement(ItemComponent, _extends({}, itemProps, {
      key: e.id,
      event: e,
      onDismiss: function onDismiss() {
        return dispatch(removeNotification(e.id));
      },
      onClick: getActionHandler(e.primaryAction),
      maxMessageLength: maxMessageLength
    })));
  }))));
};

NotificationStackBase.propTypes = {
  maxMessageLength: propTypes.number,
  spacing: propTypes.oneOfType([propTypes.number, propTypes.string]),
  width: propTypes.oneOfType([propTypes.number, propTypes.string]),
  dismissOnNavigation: propTypes.oneOfType([propTypes.bool, propTypes.func]),
  itemComponent: propTypes.elementType,
  itemProps: propTypes.any,
  className: propTypes.string,
  sx: propTypes.any,
  variant: propTypes.any
};
var NotificationStackRoot = styled(NotificationStackBase, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * Displays a stack of toast notifications
 */

var NotificationStack = function NotificationStack(props) {
  var rootProps = useThemeProps({
    props: props,
    name: componentRoot.name
  });
  return /*#__PURE__*/React.createElement(NotificationStackRoot, rootProps);
};

var NotificationStack$1 = NotificationStack;

export { NotificationStack$1 as default };
